import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import LandingPage from "./Pages/LandingPage";
import AboutChatbot from "./Pages/AboutChatbot";
import Pricing from "./Pages/Pricing";
import FrequentTopics from "./Pages/FrequentTopics";
import Solutions from "./Pages/Solutions";
import ContextProvider from "./context/Context";

function App() {
  return (
    <BrowserRouter>
      <ContextProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about-chatbot" element={<AboutChatbot />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/frequent-topic" element={<FrequentTopics />} />
          <Route path="/solutions" element={<Solutions />} />
        </Routes>
      </ContextProvider>
    </BrowserRouter>
  );
}

export default App;